// Mirror of backend `models/src/bi/template.ts`.

/**
 * Dashboards written in code that a member starts from: the four weekly
 * operations reports, and 我的看板 for an advisor or technician (spec:
 * docs/bi-default-dashboards).
 */

export enum BiTemplateKey {
  OperationsBrief = 'operations_brief',
  OperationsReport = 'operations_report',
  AdvisorReport = 'advisor_report',
  TechnicianReport = 'technician_report',
  MyDashboard = 'my_dashboard',
}

export interface BiTemplateSummary {
  key: BiTemplateKey;
  name: string;
  description: string;
  /** Part of the caller's default set. */
  recommended: boolean;
  /** False for 我的看板 when the caller is neither advisor nor technician. */
  available: boolean;
  /**
   * 我的看板, for an admin or manager: the store's advisors and technicians
   * they may create one for. Absent on every other template and caller.
   */
  subjects?: BiTemplateSubjectOption[];
}

export interface BiTemplateSubjectOption {
  memberId: number;
  name: string;
}

export interface BiCreateFromTemplateRequest {
  templateKey: BiTemplateKey;
  /**
   * `my_dashboard` only: the member it is about. Omitted: the caller.
   * Another member needs the caller to be an admin or manager.
   */
  subjectMemberId?: number;
}
